// extracted by mini-css-extract-plugin
module.exports = {"tab-section":"styles__tab-section__15PJH","tabSection":"styles__tab-section__15PJH","plain-text":"styles__plain-text__3XrB1","plainText":"styles__plain-text__3XrB1"};